module.exports = __webpack_public_path__ + "static/media/sort-desc.a529de86.svg";